import React from 'react';
import { Bookmark, BookmarkActionHandlers } from '../shared/types';
import { BookmarkListItem } from '../shared/BookmarkListItem';

interface ListLayoutProps {
  bookmarks: Bookmark[];
  handlers: BookmarkActionHandlers;
}

export const ListLayout: React.FC<ListLayoutProps> = ({ bookmarks, handlers }) => {
  return (
    <div className="bookmarks-list">
      {bookmarks.map(bookmark => (
        <BookmarkListItem
          key={bookmark.id}
          bookmark={bookmark}
          handlers={handlers}
          isGrouped={false}
        />
      ))}
    </div>
  );
};